module.exports = __webpack_public_path__ + "img/empty-star-20x20.31014a16.svg";